import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, OnDestroy} from '@angular/core';
import {WjInputModule} from '@mescius/wijmo.angular2.input';
import mermaid from 'mermaid';
import {PortfolioDataContext} from '../../data/portfolio-data-context.service';
import {PortfolioSegmentDataContext} from '../../data/portfolio-segment-data-context.service';

@Component({
    selector: 'app-home',
    imports: [
        WjInputModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements AfterViewInit, OnDestroy {

    protected readonly pfData = inject(PortfolioDataContext);
    protected readonly pfSegData = inject(PortfolioSegmentDataContext);

    protected diagramSrc = `
        %%{init: {
          "theme": "base",
          "themeVariables": {
            "clusterBkg": "#ffffff",
            "clusterBorder": "#ff0000"
          }
        }}%%

        flowchart LR

        %% --- Tiering workflow ---
        subgraph T["Tiering workflow"]
            direction LR
            T1[Dashboard Targets]
            T2["Account Data"]
            T3["Errors & Warnings"]
            T4["Portfolio Targets Report"]

            T1 --> T2 --> T3 --> T4
            click T1 "javascript:homeMmNav('abc')"
        end


        %% --- Tracking workflow ---
        subgraph R["Tracking workflow"]
            direction LR
            R1["Dashboard Tracking"]
            R2["Account Data"]
            R3["Errors & Warnings"]
            R4["Portfolio Tracking Report"]

            R1 --> R2 --> R3 --> R4
        end

        %% --- Styling to resemble the red buttons ---
        classDef redNode fill:#C21B17FF,color:#ffffff,stroke:#900000,stroke-width:2px,rx:6,ry:6;

        class T1,T2,T3,T4,R1,R2,R3,R4 redNode;
    `;
    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);

    constructor() {
        // mermaid.initialize({ startOnLoad: false, securityLevel: 'loose' });
    }

    async ngAfterViewInit(): Promise<void> {
        const thisEl = this.el.nativeElement;
        const mermaidEl = thisEl.querySelector<HTMLElement>('.mermaid')!;

        //mermaid.initialize({ startOnLoad: true, securityLevel: 'loose' });
        // const svg = await mermaid.render('someid', this.diagramSrc);
        // mermaidEl.innerHTML = svg.svg;

        // add the navigation handler, that allows the mermaid SVG to call back this component
        (window as any)['homeMmNav'] = (path: string) => this.navigateToWorkflowStep(path)
    }

    private navigateToWorkflowStep(path: string) {

    }

    ngOnDestroy(): void {
        // do not forget to remove the global mermaid function otherwise our component
        // cannot be garbage collected and the mermaid diagram will remain in memory forever
        delete (window as any)['homeMmNav'];
    }
}
